import React, { Component, Fragment } from "react";
import { format } from "date-fns";
import moment from "moment-timezone";
import { string } from "prop-types";
import { connect } from "react-redux";

import * as i18n from "util/i18n";

class FormattedDate extends Component {
    static propTypes = {
        date: string.isRequired,
        dateFormat: string,
        timeZone: string,
        dateFormatDefault: string.isRequired,
    };

    static defaultProps = {
        dateFormat: null,
        timeZone: null,
    };

    render() {
        const { date, dateFormat, dateFormatDefault, timeZone } = this.props;
        return (
            <Fragment>
                {timeZone
                    ? moment(date)
                          .tz(timeZone)
                          .format(dateFormat || dateFormatDefault)
                    : format(date, dateFormat || dateFormatDefault)}
            </Fragment>
        );
    }
}

const mapStateToProps = () => ({
    dateFormatDefault: i18n.get("datepicker.format"),
});

export default connect(mapStateToProps)(FormattedDate);
